import { Injectable } from '@angular/core';
import { CoreModule } from '../core.module';

@Injectable({
	providedIn: CoreModule,
})
export class EnvironmentService {
	constructor(
	) { }

	isLocal(): boolean {
		return window.location.hostname.includes('localhost');
	}
}
